(function () {
    var keydownBound = false;
  
    function waitForSwiper(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
        return;
      }
  
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (typeof Swiper !== 'undefined') {
          window.clearInterval(timer);
          callback();
        } else if (attempts > 40) {
          window.clearInterval(timer);
        }
      }, 100);
    }
  
    function getImages(root) {
      return Array.from(root.querySelectorAll('.seo-instagram-gallery__item--lightbox')).map(function (button) {
        return {
          src: button.dataset.fullSrc,
          alt: button.dataset.alt || ''
        };
      });
    }
  
    function initSwiper(root) {
      var container = root.querySelector('.seo-instagram-gallery__swiper');
      if (!container) return;
  
      waitForSwiper(function () {
        if (container.swiper) {
          try {
            container.swiper.destroy(true, true);
          } catch (e) {}
        }
  
        container.swiper = new Swiper(container, {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          watchOverflow: true,
          navigation: {
            nextEl: root.querySelector('.swiper-button-next'),
            prevEl: root.querySelector('.swiper-button-prev')
          }
        });
      });
    }
  
    function bindKeydown() {
      if (keydownBound) return;
      keydownBound = true;
  
      document.addEventListener('keydown', function (event) {
        var openLightbox = document.querySelector('.seo-instagram-gallery__lightbox.is-open');
        if (!openLightbox) return;
  
        var root = openLightbox.closest('[data-seo-ig-section]');
        if (!root) return;
  
        if (event.key === 'Escape') {
          root.dispatchEvent(new CustomEvent('seo-ig:close'));
        }
  
        if (event.key === 'ArrowLeft') {
          root.dispatchEvent(new CustomEvent('seo-ig:prev'));
        }
  
        if (event.key === 'ArrowRight') {
          root.dispatchEvent(new CustomEvent('seo-ig:next'));
        }
      });
    }
  
    function initLightbox(root) {
      if (root.dataset.lightboxReady === 'true') return;
  
      var lightbox = root.querySelector('.seo-instagram-gallery__lightbox');
      var imageEl = root.querySelector('.seo-instagram-gallery__lightbox-image');
      var closeBtn = root.querySelector('.seo-instagram-gallery__lightbox-close');
      var prevBtn = root.querySelector('.seo-instagram-gallery__lightbox-prev');
      var nextBtn = root.querySelector('.seo-instagram-gallery__lightbox-next');
      var backdrop = root.querySelector('.seo-instagram-gallery__lightbox-backdrop');
      var currentIndex = 0;
      var images = [];
  
      function updateImage() {
        var current = images[currentIndex];
        if (!current) return;
        imageEl.src = current.src;
        imageEl.alt = current.alt;
      }
  
      function openAt(item) {
        images = getImages(root);
        var items = Array.from(root.querySelectorAll('.seo-instagram-gallery__item--lightbox'));
        currentIndex = items.indexOf(item);
        if (currentIndex < 0) currentIndex = 0;
        updateImage();
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
  
      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        imageEl.removeAttribute('src');
        document.body.style.overflow = '';
      }
  
      function showPrev() {
        images = getImages(root);
        if (!images.length) return;
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateImage();
      }
  
      function showNext() {
        images = getImages(root);
        if (!images.length) return;
        currentIndex = (currentIndex + 1) % images.length;
        updateImage();
      }
  
      root.addEventListener('click', function (event) {
        var item = event.target.closest('.seo-instagram-gallery__item--lightbox');
        if (!item || !root.contains(item)) return;
        event.preventDefault();
        openAt(item);
      });
  
      closeBtn.addEventListener('click', closeLightbox);
      backdrop.addEventListener('click', closeLightbox);
      prevBtn.addEventListener('click', showPrev);
      nextBtn.addEventListener('click', showNext);
      root.addEventListener('seo-ig:close', closeLightbox);
      root.addEventListener('seo-ig:prev', showPrev);
      root.addEventListener('seo-ig:next', showNext);
  
      bindKeydown();
      root.dataset.lightboxReady = 'true';
    }
  
    function initSection(root) {
      if (!root) return;
      initSwiper(root);
      initLightbox(root);
    }
  
    function initAll() {
      document.querySelectorAll('[data-seo-ig-section]').forEach(initSection);
    }
  
    function onSectionLoad(event) {
      var section = event.target.querySelector('[data-seo-ig-section]');
      initSection(section);
    }
  
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
  
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:reorder', onSectionLoad);
  })();
  